module.exports = __webpack_public_path__ + "img/canbadge_heart_w57mm.9e65a0bb.png";